<script>
  export let date;
  export let loggedStatus = [];
  $: savedValues = loggedStatus.reverse().find(
    (item) =>
      item.date === date.toISOString().slice(0, 10) ||
      item.date ===
        date.toLocaleString("no", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
  );
  $: health = savedValues !== undefined ? savedValues.health : {};
</script>

<div class="week-calendar__day-status-wrap">
  {#if health.ill}
    <i class="week-calendar__day-status week-calendar__day-status--ill" />
  {/if}
  {#if health.travelDay}
    <i
      class="week-calendar__day-status week-calendar__day-status--travelling"
    />
  {/if}
  {#if health.injured}
    <i class="week-calendar__day-status week-calendar__day-status--injured" />
  {/if}
  {#if health.menstrualCycle}
    <i
      class="week-calendar__day-status week-calendar__day-status--menstruation"
    />
  {/if}
  {#if health.height}
    <i class="week-calendar__day-status week-calendar__day-status--altitude" />
  {/if}
  {#if health.dayOff}
    <i class="week-calendar__day-status week-calendar__day-status--freeday" />
  {/if}
  {#if health.competitionDay}
    <i
      class="week-calendar__day-status week-calendar__day-status--competition"
    />
  {/if}
</div>
